import React from "react";
import styled from "styled-components";

import breakpoints from "core/breakpoints";
import { StyledAnimationContainer } from "./styles";

import { useAttributionBacklink } from "icons/AttributionBacklink/Context";
import { useViewport } from "js/hooks/useViewport";

let AnimationContainer = ({ className, children }) => {
    const { downloadCount } = useAttributionBacklink();

    const { browserWidth } = useViewport();
    const isDesktop = browserWidth > breakpoints.tablet.px;

    return (
        <StyledAnimationContainer
            className={className}
            startAnimation={!!downloadCount && !!isDesktop}
        >
            {children}
        </StyledAnimationContainer>
    );
};

AnimationContainer = styled(AnimationContainer)``;
export default AnimationContainer;
